module.exports = __webpack_public_path__ + "img/kh_01.2178bc1e.webp";